// import { useState } from "react";
import { Link } from "react-router-dom";
import style from "../../styles/grid.module.css";
import { GetGanancias } from "../../actions/ganancias";
import { Pencil, SquareX, CirclePlus } from "lucide-react";

const API_URL = process.env.REACT_APP_URL_DIR + "ganancia";


export default function Pago() {
   const token = localStorage.getItem("token");
   const {data,refetch } =  GetGanancias();

   const handleDelete = async (id) => {
   if (!window.confirm("¿Está seguro que desea eliminar este registro?")) {
      return;
   }      
      await fetch(`${API_URL}/${id}`, {
         method: "DELETE",
         headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
         },
      });
      refetch();
   };

   return (
      <div className={style.tableCli}>
         <div>
            <div className={style.header}>
               <div className={style.gridTitle}>
                  <h2>Recargo por Venta</h2>
               </div>
               <div>
                  <Link
                     to={"/formGanancia"}
                     className="dLink"
                     title="Alta Pago"
                     state={{
                        id_primary: 0,
                        id: 0,
                        companyId: 0,
                        nombre: "",
                        email: "",
                        tewlefono: 0,
                        cod_status: 1,
                        documento:"",
                     }}
                  >
                     {" "}
                     <CirclePlus style={{color: 'white'}}/>
                     {/* <button className={style.inputBtnNew}>Alta Ganancia</button> */}
                  </Link>
                  &nbsp;&nbsp;
               </div>
            </div>
         </div>
         <br />
         <div>
            <table className={style.gridTable}>
               <thead>
                  {/* <tr className={style.trBuscar}>
                     <th>Buscar</th>
                     <th className={style.thCli}>
                        <input
                           onKeyPress={(e) => handleInputChange(e)}
                           onChange={(e) => setName(e.target.value)}
                           type="text"
                           id="search-navbar"
                           placeholder="Buscar..."
                           value={nombre}
                        />
                     </th>
                     <th className={style.thCli}></th>
                     <th className={style.thCli}></th>
                     <th>&nbsp;</th>
                  </tr> */}
                  <tr  className={style.trTitle}>
                     {/* <th className={style.title}>ID</th> */}
                     <th className={style.title}>&nbsp;Descripcion</th>
                     <th className={style.title2}>% Recargo</th>
                     <th>Acciones</th>
                  </tr>
               </thead>
               <tbody>
                  {data?.length>0 &&
                     data?.map((pag,i) => {
                        return (
                           <tr key={i} className={style.trdatos}>
                              {/* <td className={style.style_td}>{pag.id}</td> */}
                              <td className={style.style_td}>&nbsp;{pag.descripcion}</td>
                              <td className={style.style_email}>{pag.recargo}</td>
                              <td className={style.dLink}>
                                 <Link
                                    to={"/formGanancia"}
                                    state={{
                                       id_primary: pag.id_primary,
                                       id: pag.id,
                                       companyId: pag.companyId,
                                       descripcion: pag.descripcion,
                                       recargo: pag.recargo,
                                       cod_status:pag.cod_status,
                                    }}
                                 >
                                    <Pencil/>
                                    {/* <img src={edit} height="30px" alt="" /> */}
                                    {/* <FcAcceptDatabase style={estilo} />  */}
                                 </Link>
                                 &nbsp;&nbsp;
                                 &nbsp;&nbsp;
                                 <span
                                    title="Eliminar"
                                    className="lucideIconDel"
                                    onClick={() => handleDelete( pag.id)}
                                 >
                                    <SquareX />
                                 </span>                                 

                              </td>
                           </tr>
                        );
                     })}
               </tbody>
            </table>
         </div>
      </div>
   );
}
